// extracted by mini-css-extract-plugin
export var bubble = "_30-0";
export var container = "_30-3";
export var contrastBorder = "_30-4";
export var greyOut = "_30-2";
export var initialsWrapper = "_30-1";
export var large = "_30-9";
export var medium = "_30-8";
export var mediumSmall = "_30-7";
export var mediumSmallMedium = "_30-c";
export var micro = "_30-5";
export var small = "_30-6";
export var tiny = "_30-b";
export var xTiny = "_30-a";